export function confirm(message: string) {
    return window.confirm(message);
}